export default (props, traits) => ({
  root: {
    opacity: 0.25,
    textAlign: 'center'
  }
})
